import { connect } from 'react-redux';

import Actions from '../actions';
import LocaleSelector from '../components/shared/header/locale-selector';

const mapStateToProps = (state, ownProps) => ({
    currentLocale: state.locale.currentLocale,
});

const mapDispatchToProps = (dispatch) => ({
    setLocale: (locale) => {
        dispatch(Actions.setLocale(locale));
    },
});

const LocaleSelectorConnector = connect(mapStateToProps, mapDispatchToProps)(LocaleSelector);

export default LocaleSelectorConnector;



/** WEBPACK FOOTER **
 ** ./src/containers/locale-selector-connector.js
 **/